import React from "react";

import { FormSubscribe, ResetButton, SubmitButton } from "@performyard/py-components";

import Spacer from "../../../../components/Spacer";

type SettingsFormFooterProps = {
	formId: string;
	isPending: boolean;
};

export const SettingsFormFooter = ({ formId, isPending }: SettingsFormFooterProps) => {
	return (
		<>
			<Spacer height={5} />
			<FormSubscribe id={`${formId}-unsaved-changes`} selector={(state) => [state?.isDirty]}>
				{([isDirty]) => {
					return (
						<div data-form-dirty={isDirty} key="form-footer" className="flex justify-end gap-2">
							{isDirty && (
								<span data-testid="discard-changes">
									<ResetButton color="neutral" variant="outline" size="large">
										Discard
									</ResetButton>
								</span>
							)}
							<span data-testid="save-changes">
								<SubmitButton
									color="green"
									size="large"
									loading={isPending}
									disabled={isPending || !isDirty}
								>
									Save Changes
								</SubmitButton>
							</span>
						</div>
					);
				}}
			</FormSubscribe>
		</>
	);
};
